import React from "react";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";
import { Link } from "react-router-dom";

import { Events, animateScroll as scroll } from 'react-scroll'
import {Col,Row,Button,CardHeader,Card, CardBody,NavLink} from 'reactstrap';
// import "animate.css/animate.min.css";
import Fade from 'react-reveal/Fade';


class Home extends React.Component {
  componentDidMount() {
      scroll.scrollToTop();
        Events.scrollEvent.register('begin', function(to, element) {
        // console.log("begin", arguments);
        });
   
      Events.scrollEvent.register('end', function(to, element) {
        // console.log("end", arguments);
      });
      this.getLocation();
    //   scrollSpy.update();
    // document.body.classList.toggle("/");
  }
  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
    // document.body.classList.toggle("/");
  }
  getLocation(){
    fetch('http://ip-api.com/json')
    .then(response => {
        return response.json();
       }, "jsonp")
      .then(res => {
        console.log(res)
      })
      .catch(err => console.log(err));
  }
  render() {
    return (
      <>
        <IndexNavbar />
        <div className="wrapper" style={{overflowX:'hidden',overflowY:"hidden"}}>
        
            <div className="page-header header-filter">
                <img alt="..." className="mainbg" src={require("assets/custom/homebg2.jpg")}/>
                    <div className="content-home">
                        <Row className="row-grid">
                                <Col style={{textAlign:'center',paddingTop:'14%',paddingLeft:'8%'}} md="6">
                                    <Fade big>
                                        <h1 className="h1-seo" style={{fontFamily:"Boveno , serif",color:'white',textShadow:'2px 1px #e14fca'}}><b>EDICODETOR</b></h1>
                                        <h2 style={{fontFamily:"Boveno",color:'white',textShadow:'2px 1px #e14fca'}}>
                                            React & Node - JS Based Online Code Editor
                                            <br/>
                                            Python • Java • C • C++
                                        </h2>
                                        <NavLink to="/editor" tag={Link}>
                                            <Button style={{border:'1px solid' , fontWeight:"bold"}}  color="neutral" className="btn-lg" value="Start Playing"><i style={{fontSize:'2rem'}}  className="tim-icons icon-controller"/> &nbsp;Start Playing</Button>
                                        </NavLink>
                                    </Fade>
                                </Col>
                                <Col md="6" style={{textAlign:'center',paddingTop:'3%'}}>
                                    <Fade big>
                                        <img alt="..." src={require("assets/custom/main.jpg")} height="95%" width="95%"/>
                                    </Fade>
                                </Col>
                        </Row> 
                    </div>
            </div>

            <section className="section" style={{backgroundColor:'white'}}>
                    {/* <img className="sectionbg" alt="..." src={require('../../assets/custom/18704.jpg')}/> */}
                    <Row className="row-grid" style={{display:'flex'}}>
                        <Col md="3">
                        </Col>
                        <Col md="6" style={{textAlign:'center',float:'right'}}>
                            <Fade big>
                                <img alt="..." src={require("assets/custom/staysafe.png")} style={{}}/>
                                <br></br>
                                <span style={{color:'#481380',fontSize:'2rem'}}>Stay</span>
                                <span style={{color:'#ff5126',fontSize:'2.5rem'}}> Home</span>
                                <span style={{color:'#481380',fontSize:'2rem'}}> Stay</span>
                                <span style={{color:'#ff5126',fontSize:'2.5rem'}}> Safe</span>
                                <br></br>
                                <span style={{color:'#481380',fontSize:'2.5rem'}}><small>And Code</small></span>
                                &nbsp;  
                                <i  style={{color:'#ff5126',fontSize:'2.5rem'}} className="tim-icons icon-laptop"></i>
                            </Fade>
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
            </section>
            <section className="section" name="shortcut">
                    <img className="sectionbg" alt="..." src={require('../../assets/custom/homebg.jpg')}/>
                    <Row className="row-grid">
                        <Col md="6" style={{textAlign:'center',paddingTop:'1%',paddingLeft:""}}>
                            <Fade big>
                                <h1 style={{color:'#ff3666'}}><small>Line Operations</small></h1>
                                <table style={{backgroundColor:'black', color:'#ff3666',textAlign:'center',marginLeft:'0%',marginRight:'0%'}} className="table  table-dark">
                                    <thead style={{color:'black',backgroundColor:'#ff3666',fontSize:'1rem'}}>
                                        <tr>
                                            <th>SHORTCUTS</th>
                                            <th>OPERATION</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{color:'black'}}>
                                        <tr>
                                            <td>Ctrl-D</td><td>Remove line</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-Down</td><td>Copy lines down</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-Up</td><td>Copy lines up</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Down</td><td>Move lines down</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Up</td><td>Move lines up</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Delete</td><td>Remove to line end</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Backspace</td><td>Remove to linestart</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Backspace</td><td>Remove word left</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Delete</td><td>Remove word right</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Fade>
                        </Col>
                        <Col md="6" style={{textAlign:'center',paddingTop:'1%',paddingLeft:""}}>
                            <Fade big>
                                <h1 style={{color:'lightgreen'}}><small>Find & Replace || Folding</small></h1>
                                <table style={{backgroundColor:'black', color:'#ff3666',textAlign:'center',marginLeft:'0%',marginRight:'0%'}} className="table table-dark">
                                    <thead style={{color:'white',backgroundColor:'lightgreen',fontSize:'1rem'}}>
                                        <tr>
                                            <th>SHORTCUTS</th>
                                            <th>OPERATION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ctrl-F</td><td>Find</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-H</td><td>Replace</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-K</td><td>Find next</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-K</td><td>Find previous</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-L, Ctrl-F1</td><td>Fold selection</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-L, Ctrl-Shift-F1</td><td>Unfold</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-0</td><td>Fold all</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-0</td><td>Unfold all</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Fade>
                        </Col>
                    </Row>
                    <img className="sectionbg" alt="..." src={require('../../assets/custom/homebg.jpg')}/>
                    <Row className="row-grid">
                    <Col md="6" style={{textAlign:'center',paddingTop:'1%',paddingLeft:"5%"}}>
                        <Fade big>
                            <h1 style={{color:'#fbd80b'}}><small>Selection</small></h1>
                            <table style={{backgroundColor:'black',maxHeight:'50%',maxWidth:'initial',overflowX:"hidden",color:'#ff3666',textAlign:'center',marginLeft:'0%',marginRight:'0%'}} className="table  table-dark">
                                    <thead style={{color:'white',backgroundColor:'#fbd80b',fontSize:'1rem'}}>
                                        <tr>
                                            <th>SHORTCUTS</th>
                                            <th>OPERATION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ctrl-A</td><td>Select all</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-Left</td><td>Select left</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-Right</td><td>Select right</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-Left</td><td>Select word left</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-Right</td><td>Select word right</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-Home</td><td>Select line start</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-End</td><td>Select line end</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-Right</td><td>Select to line end</td>
                                        </tr>
                                        <tr>
                                            <td>Alt-Shift-Left</td><td>Select to line start</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-Up</td><td>Select up</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-Down</td><td>Select down</td>
                                        </tr>
                                        {/* <tr>
                                            <td>Shift-PageUp</td><td>Select page up</td>
                                        </tr>
                                        <tr>
                                            <td>Shift-PageDown</td><td>Select page down</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-Home</td><td>Select to start</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-End</td><td>Select to end</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-D</td><td>Duplicate Selection</td>
                                        </tr>
                                        <tr>
                                            <td>Ctrl-Shift-P</td><td>Select to matching bracket</td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </Fade>
                        </Col>
                        <Col md="6">
                            <Fade big>
                                <img  alt="..." src={require('../../assets/custom/naice.jpg')} style={{paddingRight:'2pc',paddingTop:'10%'}}/>
                                <br/>
                                <span style={{fontSize:'1.5em',color:'#ff3666', textAlign:"center", paddingLeft:'25%'}}>Find More Shortcuts<a href="https://github.com/ajaxorg/ace/wiki/Default-Keyboard-Shortcuts"> here</a></span>
                            </Fade>
                        </Col>
                    </Row>
            </section>
            <section className="section" name="guideline" style={{backgroundColor:'black'}}>
                <Fade big>
                    <h1 className="text-center" style={{fontFamily:"Boveno",color: '#b9e810'}}><b>Guidelines</b></h1>
                </Fade>
                    <Row className="row-grid">
                        <Col md="6">
                            <Card className="card-plain">
                                <CardHeader>
                                    <Fade big>
                                        <h1 className="profile-title text-left">Miscellaneous</h1>
                                        <h5 className="text-on-back">4:20</h5>
                                    </Fade>
                                </CardHeader>
                                <CardBody>
                                    <Fade big>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            There are two ways to run the code:
                                        </p>
                                        <h5 className="text-on-back-sub"><small>1</small></h5>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            <span className="profile-title-sub">You can run code directly using <span style={{color:'#ff3666'}}>(Ctrl+Enter)</span> shortcut or using the <span style={{color:'greenyellow'}}>Run Button in the navbar</span> if it <span style={{color:'cyan'}}>does'nt require any user input.</span>  </span>
                                        </p>
                                        <h5 className="text-on-back-sub" ><small>2</small></h5>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            <span className="profile-title-sub"><span style={{color:'cyan'}}>Code which requires user inputs</span>  will give an error if user input is not specified. In order to specify user input you can click on the <span style={{color:'greenyellow'}}>Run Button in the navbar</span> or using <span style={{color:'#ff3666'}}>(Shift+Enter).</span> Shortcut</span>
                                        </p>
                                    </Fade>      
                                </CardBody>
                            </Card>
                        </Col>

                        <Col md="6" style={{textAlign:'center',paddingTop:'1%',}}>
                            <Fade big>
                                <img  alt="..." src={require('../../assets/custom/coding.jpg')} style={{paddingRight:'2pc'}} height="85%" width="80%"/>
                            </Fade>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4" style={{textAlign:'',paddingTop:'',paddingLeft:""}}>
                            <Card className="card-plain">
                                <CardHeader>
                                    <Fade big>
                                        <h1 className="profile-title text-left">Java</h1>
                                        <h5 className="text-on-back">01</h5>
                                    </Fade>
                                </CardHeader>
                                <CardBody>
                                    <Fade big>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            <span style={{color:'#ff3666'}}>Class implementing the main method</span> should be  <span style={{color:'greenyellow'}}>public</span> and <span style={{color:'orange'}}>compile-time error</span> <span style={{color:'#ff3666'}}>won't </span>be <span style={{color:'yellow'}}>highlighted</span> or displayed on the <span style={{color:'grey'}}>terminal</span>
                                        </p>
                                    </Fade>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4">
                            <Card className="card-plain">
                                <CardHeader>
                                    <Fade big>
                                        <h1 className="profile-title text-left">C & C++</h1>
                                        <h5 className="text-on-back">02</h5>
                                    </Fade>
                                </CardHeader>
                                <CardBody>
                                    <Fade big>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            <span style={{color:'#ff3666'}}>Return type should be int in main method</span><span style={{color:'greenyellow'}}><br/><br/> int main( )&#123;<br/><span style={{color:'grey'}}>&nbsp;&nbsp;&nbsp;//Write your code</span><br/> &nbsp;&nbsp;&nbsp;return 0;<br/>&#125;</span><br/><br/> and <span style={{color:'orange'}}>compile-time error</span> <span style={{color:'#ff3666'}}>won't </span>be <span style={{color:'yellow'}}>highlighted</span> or displayed on the <span style={{color:'grey'}}>terminal</span>
                                        </p>
                                    </Fade>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4">
                            <Card className="card-plain">
                                <CardHeader>
                                    <Fade big>
                                        <h1 className="profile-title text-left">Python</h1>
                                        <h5 className="text-on-back">03</h5>
                                    </Fade>
                                </CardHeader>
                                <CardBody>
                                    <Fade big>
                                        <p className="profile-description text-left" style={{fontSize:'1.5rem'}}>
                                            <span style={{color:'#ff3666'}}> Didn't</span><span style={{color:'greenyellow'}}> observe</span> <span style={{color:'orange'}}>anything yet.<br/></span>If you find bugs let us know <br/>
                                        </p>
                                        <NavLink style={{paddingLeft:'5pc'}} to="/report" tag={Link}>
                                            <Button style={{border:'1px solid' , fontWeight:"bold"}}  color="neutral" className="btn-sm" value="Start Playing"><i style={{fontSize:'2rem'}}  className="tim-icons icon-settings"/> &nbsp;Report</Button>
                                        </NavLink>
                                    </Fade>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
            </section>
            <Footer />
        </div>
      </>
    );
  }
}

export default Home;
